<template>
<Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 mb-2">
            <div class="wrapper buyerseller-wrapper">
                <div class="row wrapper-inner-row align-items-center">
                    <div class="col-xl-4 col-lg-4 col-md-4">
                        <div class="currency-select-info">
                            <div class="currey-select-box">
                                <Dropdown v-model="selectedCurrency" :options="tokenName" optionLabel="symbol" placeholder="Select Token" @change="getRound"/>
                            </div>
                            <!--currey-select-box-->
                        </div>
                        <!--currency-select-info-->
                    </div>
                    <!--col-xl-4 col-lg-4 col-md-4-->
                    <div class="col-xl-4 col-lg-4 col-md-4">
                        <div class="currency-select-info">
                            <div class="currey-select-box">
                                <Dropdown v-model="selectedRound" :options="round" optionLabel="name" placeholder="Select Round" @change="myProvider"/>
                            </div>
                            <!--currey-select-box-->
                        </div>
                        <!--currency-select-info-->
                    </div>
                </div>
                <!--row wrapper-inner-row-->
            </div>
            <!--wrapper buyerseller-wrapper-->
        </div>

        <div class="col-xl-12 col-lg-12 col-md-12 mb-2">
            <div class="wrapper buyerseller-wrapper">
                <div class="row wrapper-inner-row align-items-center">
                    <div class="col-xl-3 col-lg-3 col-md-3">
                        <div class="currency-select-info">
                            <div class="currey-select-box">
                              <h4 class="mb-0" style="color:green;">Total Round Limit  :- <span style="color:black;"> <b>{{ portfolio.total_round_coins }}</b></span></h4>
                                <!-- <Dropdown v-model="selectedCurrency" :options="tokenName" optionLabel="symbol" placeholder="Select Token" @change="getRound"/> -->
                            </div>
                            <!--currey-select-box-->
                        </div>
                        <!--currency-select-info-->
                    </div>
                    <div class="col-xl-3 col-lg-3 col-md-3">
                        <div class="currency-select-info">
                            <div class="currey-select-box">
                                 <h4 class="mb-0" style="color:green;">Total Users  :- <span style="color:black;"><b>{{ portfolio.total_user }}</b></span></h4>
                                <!-- <Dropdown v-model="selectedRound" :options="round" optionLabel="name" placeholder="Select Round" @change="myProvider"/> -->
                            </div>
                            <!--currey-select-box-->
                        </div>
                        <!--currency-select-info-->
                    </div>
                      <div class="col-xl-3 col-lg-3 col-md-3">
                        <div class="currency-select-info">
                            <div class="currey-select-box">
                                <h4 class="mb-0" style="color:green;">Total Round Sell Coin  :- <span style="color:black;"><b>{{ portfolio.total_sell_coin }}</b></span></h4>
                                <!-- <Dropdown v-model="selectedRound" :options="round" optionLabel="name" placeholder="Select Round" @change="myProvider"/> -->
                            </div>
                            <!--currey-select-box-->
                        </div>
                        <!--currency-select-info-->
                    </div>
                     <div class="col-xl-3 col-lg-3 col-md-3">
                        <div class="currency-select-info">
                            <div class="currey-select-box">
                                <h4 class="mb-0" style="color:red;">Total Pending  Coin  :- <span style="color:black;"><b>{{ portfolio.total_pending_coins }}</b></span></h4>
                                <!-- <Dropdown v-model="selectedRound" :options="round" optionLabel="name" placeholder="Select Round" @change="myProvider"/> -->
                            </div>
                            <!--currey-select-box-->
                        </div>
                        <!--currency-select-info-->
                    </div>
                </div>
                <!--row wrapper-inner-row-->
            </div>
            <!--wrapper buyerseller-wrapper-->
        </div>

        
        <!--col-xl-12 col-lg-12 col-md-12-->
          <simplebar style="max-height: 600px" v-if="showTable">
                            <div class="table-responsive">

                                <b-table :items="orderData" :fields="fields" responsive="sm" :per-page="perPage"
                                    :current-page="currentPage" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
                                    :busy="loading" ref="table" show-empty>
                                    <template #empty>
                                        <div class="d-flex justify-content-center mb-3">
                                            No Record Found
                                        </div>
                                    </template>

                                    <template #table-busy>
                                        <div class="text-center text-info my-2">
                                            <b-spinner class="align-middle"></b-spinner>
                                            <!-- <strong>Loading...</strong> -->
                                        </div>
                                    </template>

                                    <template v-slot:cell(id)="data">
                                        <div v-if="data.item.id">
                                            {{ data.item.id }}
                                        </div>
                                    </template>

                                    <template v-slot:cell(user_name)="data">
                                        <div v-if="data.item.user_id">
                                            {{ data.item.user.name }}
                                        </div>
                                    </template>

                              

                                    <template v-slot:cell(createdAt)="data">
                                        <div v-if="data.item.createdAt">
                                             {{ new Date(data.item.createdAt).toLocaleString("en-us",Date_options) }}
                                        </div>
                                    </template>


                                    <template v-slot:cell(token)="data">
                                        <div v-if="data.item.name">
                                            {{data.item.name }}
                                        </div>
                                    </template>

                                    <template v-slot:cell(action)="data">
                                        <div class="text-capitalize" v-if="data.item.status == 'pending'">
                                        <button class="btn btn-primary" @click="paytouser(data.item.id)"> Pay</button>
                                        </div>
                                        <div v-else>
                                            <span style="color:green;font-weight:800;"> Paid </span>
                                        </div>
                                    </template>

                       

                                </b-table>
                            </div>
                            <div class="row m-0">
                                <div class="col p-0">
                                    <div class="dataTables_paginate paging_simple_numbers float-end">
                                        <ul class="pagination pagination-rounded mb-0">
                                            <!-- pagination -->
                                            <b-pagination v-model="currentPage" :total-rows="totalRows"
                                             @page-click='myProvider'  :per-page="perPage"></b-pagination>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </simplebar>
    </div>
</Layout>
</template>

<script>
import Layout from "../../layouts/main";
import ApiClass from "../../api/api";
import simplebar from "simplebar-vue";
import PageHeader from "@/components/page-header";
// import DataTable from "primevue/datatable";
// import Column from "primevue/column";
// import ColumnGroup from 'primevue/columngroup';
// import InputText from "primevue/inputtext";
// import MultiSelect from 'primevue/multiselect';
import Dropdown from "primevue/dropdown";
import Swal from "sweetalert2";

// import Calendar from "primevue/calendar";
// import ProgressBar from 'primevue/progressbar';

export default {
    components: {
        Layout,
        PageHeader,
        simplebar,
        // DataTable,
        Dropdown,
        // Calendar,
        // Column,
        // InputText,
    },
    data() {
        return {
            showTable : false,
             Date_options: {
                day: 'numeric',
                month: 'long',
                year: 'numeric'
            },
            title: "Orders",
            items: [{
                    text: "Launchpad",
                    href: "#",
                },
                {
                    text: "Orders",
                    active: true,
                },
            ],
            orderData: [],
            portfolio:{
                total_sell_coin: 0,
                total_user: 0,
                total_round_coins: 0,
                total_pending_coins: 0 
            },
            loading: true,
            selectedCurrency: { },
            selectedRound: { },
            tokenName: [],
            round: [],
            currentPage:1,
            totalRows:0,
            perPage:10,
            sortBy: "value",
            sortDesc: false,
            fields: [{
                key: "id",
                value: "id",
                sortable: false,
            },
            {
                key: "user_name",
                value: "user_name",
                sortable: false,
            }, 
                {
                key: "token",
                value: "name",
                sortable: false,
            },{
                key: "amount",
                value: "amount",
                sortable: false,
            },
            {
                key: "price",
                value: "price",
                sortable: false,
            },
            {
                key: "currency",
                value: "currency",
                sortable: false,
            },
            {
                key: "status",
                value: "status",
                sortable: false,
            },
            {
                key: "total",
                value: "total",
                sortable: false,
            },
            {
                key: "createdAt",
                value: "createdAt",
                sortable: false,
            },
            {
                key: "action",
                value: "action",
                sortable: false,
            },
            ],
        };
    },
    async mounted() {
         var result1 = await ApiClass.getNodeRequest("launchpad/get_tokens", true);
        this.tokenName = result1.data?.data;
    },
    methods: {
        async getRound(){
          
            this.round = this.selectedCurrency.launchpad_rounds[0]?this.selectedCurrency.launchpad_rounds[0].rounds:[];
            for (let i = 0; i < this.round.length; i++) {this.round[i].name='Round '+(i+1); }
               if(this.round.length==0){this.round.push({'name':'No Round Available'})}
         
           
         },
         async myProvider() {
            this.showTable = true;
            console.log(this.currentPage);
            this.loading = true;
              ApiClass.getNodeRequest("launchpad/get_orders/"+this.selectedRound.t_id+'?page='+ this.currentPage+'&per_page='+this.perPage, true).then((res) => {
                   if (res.data.status_code == 1) {
                    
                            this.loading = false;
                            this.orderData = res.data.data ? res.data.data.data : [];
                            this.portfolio = res.data.portfolio ? res.data.portfolio : {};
                            this.currentPage = res.data.data ? res.data.data.current_page : '';
                            this.totalRows = res.data.data ? res.data.data.total : '';

                            
                        }
            //  console.log({res});
             }).bind(this);
         },
           async paytouser(id){
         Swal.fire({
                title: "Are you sure?",
                text: "You won't be able to revert this!",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#f46a6a",
                confirmButtonText: "Yes, Pay it!",
        }).then(async (result) => {
            if (result.value) {
                var response = await ApiClass.postNodeRequest(
                    "launchpad/transfer-token-by-admin/" + id,
                    true
                );
                this.$refs.table.refresh();
                if(response.data.status_code != 1){
                    Swal.fire("", response.data.message, "error");
                    return;
                }
                Swal.fire("Paid!", response.data.message, "success");
                return;
            }
        });
    }
    },
};
</script>
  
<style lang="scss">
.p-paginator {
    .p-paginator-current {
        margin-left: auto;
    }
}

.p-progressbar {
    height: 0.5rem;
    background-color: #d8dadc;

    .p-progressbar-value {
        background-color: #00acad;
    }
}

.table-header {
    display: flex;
    justify-content: space-between;
}

.p-datepicker {
    min-width: 25rem;

    td {
        font-weight: 400;
    }
}

.p-datatable.p-datatable-customers {
    .p-datatable-header {
        padding: 5rem;
        text-align: left;
        font-size: 1.5rem;
    }

    .p-paginator {
        padding: 1rem;
    }

    .p-datatable-thead>tr>th {
        text-align: left;
    }

    .p-datatable-tbody>tr>td {
        cursor: auto;
    }

    .p-dropdown-label:not(.p-placeholder) {
        text-transform: uppercase;
    }
}

.p-calendar .p-datepicker {
    width: 350px;
}

.p-inputtext {
    width: 100%;
}

/* Responsive */
.p-datatable-customers .p-datatable-tbody>tr>td .p-column-title {
    display: none;
}

@media screen and (max-width: 64em) {
    .p-datatable {
        &.p-datatable-customers {

            .p-datatable-thead>tr>th,
            .p-datatable-tfoot>tr>td {
                display: none !important;
            }

            .p-datatable-tbody>tr>td {
                text-align: left;
                display: block;
                border: 0 none !important;
                width: 100% !important;
                float: left;
                clear: left;
                border: 0 none;

                .p-column-title {
                    padding: 0.4rem;
                    min-width: 30%;
                    display: inline-block;
                    margin: -0.4rem 1rem -0.4rem -0.4rem;
                    font-weight: bold;
                }
            }
        }
    }
}
</style>
